import React, {forwardRef} from "react";
import styled from "styled-components";
import OverViewCard from "./OverviewCard";
import {ProgressBarChart} from "../../components/ProgressBarChart/ProgressBarChart";
import {black, inter, lemonMilk, white} from "../../Theme";

const StyledPlanOfActionScreenExport = styled.div`
    position: fixed;
    top: 0;
    left: -10000px;
    width: 794px; // 210mm in pixels (A4 format)
    box-sizing: border-box;
    padding: 36px 40px 48px;
    background: transparent;

    /* Uncomment to debug */
    /* left: 0px;
    background-color: white;
    z-index: 2147483647;
    overflow-y: auto;
    height: 100%; */
`;

const Title = styled.div`
    font-family: ${lemonMilk};
    font-style: normal;
    font-weight: normal;
    font-size: 28px;
    color: ${black};
    text-align: center;
    margin: 0 0 24px;
    width: 100%;
`;

const Subtitle = styled.div`
    font-family: ${inter};
    font-size: 16px;
    color: ${black};
    text-align: center;
    width: 100%;
    margin: 0 0 24px;
`;

const Wrapper = styled.div`
    width: 100%;
    max-width: 500px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 28px;
`;

const BarChartOuter = styled.div`
    width: 100%;
    aspect-ratio: 1 / 1;
    background: ${white};
    position: relative;
    min-height: 280px;
`;

const BarChartInner = styled.div`
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    container-type: inline-size;
`;

export const PlanOfActionScreenExport = forwardRef(function PlanOfActionScreenExport({period, subtitle, ...props}, ref) {
    if (!period) return null;

    return (
        <StyledPlanOfActionScreenExport ref={ref} aria-hidden="true" id="test">
            <Title>{period.title}</Title>
            {subtitle && <Subtitle>{subtitle}</Subtitle>}
            <Wrapper>
                <BarChartOuter>
                    <BarChartInner>
                        <ProgressBarChart data={period} pdfExport={true} />
                    </BarChartInner>
                </BarChartOuter>
                <OverViewCard period={period} pdfExport={true} {...props} />
            </Wrapper>
        </StyledPlanOfActionScreenExport>
    );
});